import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Collapse } from 'react-bootstrap';
import { Dropdown } from 'react-bootstrap';
import { connect } from 'react-redux'

import SideBarLoading from '../../components/Placeholderloadings/SideBarLoading'

class Sidebar extends Component {
  state = {};

  toggleMenuState(menuState) {
    if (this.state[menuState]) {
      this.setState({ [menuState]: false });
    } else if (Object.keys(this.state).length === 0) {
      this.setState({ [menuState]: true });
    } else {
      Object.keys(this.state).forEach(i => {
        this.setState({ [i]: false });
      });
      this.setState({ [menuState]: true });
    }
  }

  getNome(string) {
    if (string) {
      let name = string.split(" ")
      return `${name[0]} ${name[1]}`
    }
    return 'Usuário'
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  onRouteChanged() {
    document.querySelector('#sidebar').classList.remove('active');
    Object.keys(this.state).forEach(i => {
      this.setState({ [i]: false });
    });

    const dropdownPaths = [
      { path: '/dashboard/cadastro', state: 'cadastroUiMenuOpen' },
      { path: '/dashboard/escala', state: 'escalaUiMenuOpen' },
      { path: '/dashboard/movimentac', state: 'movimentacaoUiMenuOpen' },
      {path: '/dashboard/ponto', state: 'pontoUiMenuOpen'},
      { path: '/dashboard/ferramenta', state: 'ferramentaUiMenuOpen' },
      { path: '/dashboard/relatorio', state: 'relatorioUiMenuOpen' },
      { path: '/dashboard/configurac', state: 'configuracaoUiMenuOpen' },
      { path: '/usuario', state: 'usuarioUiMenuOpen' },
      { path: '/basic-ui', state: 'basicUiMenuOpen' },
      { path: '/form-elements', state: 'formElementsMenuOpen' },
      { path: '/tables', state: 'tablesMenuOpen' },
      { path: '/icons', state: 'iconsMenuOpen' },
      { path: '/charts', state: 'chartsMenuOpen' },
      { path: '/user-pages', state: 'userPagesMenuOpen' },
    ];

    dropdownPaths.forEach((obj => {
      if (this.isPathActive(obj.path)) {
        this.setState({ [obj.state]: true })
      }
    }));

  }
  render() {
    const { usuario, tipoUsuario, imagemUrl, loading } = this.props;
    return (
      <nav className="sidebar sidebar-offcanvas" id="sidebar">
        <div className="text-center sidebar-brand-wrapper d-flex align-items-center">
          <a className="sidebar-brand brand-logo" href="/"><img src={require("../../../assets/images/Ativo-1@4x.png")} alt="logo" /></a>
          <a className="sidebar-brand brand-logo-mini pt-3" href="/"><img src={require("../../../assets/images/Ativo-8-1@4x.png")} alt="logo" /></a>
        </div>
        {loading ? <SideBarLoading /> :
          <ul className="nav">
            <li className="nav-item nav-profile not-navigation-link">
              <div className="nav-link">
                <Dropdown>
                  <Dropdown.Toggle className="nav-link user-switch-dropdown-toggler p-0 toggle-arrow-hide bg-transparent border-0 w-100">
                    <div className="d-flex justify-content-between align-items-start">
                      <div className="profile-image">
                        {imagemUrl && <img src={imagemUrl} alt="profile" />}
                      </div>
                      <div className="text-center">
                        <div className="row">
                      <span style={{marginTop: '2px', marginRight: '2px'}} className="status-indicator online"></span>
                      <p className="profile-name">{usuario}</p>
                      </div>
                        <small className="designation text-muted text-small">{tipoUsuario}</small>
                        
                      </div>
                    </div>
                  </Dropdown.Toggle>
                  {/* <Dropdown.Menu className="preview-list navbar-dropdown">
                  <Dropdown.Item className="dropdown-item p-0 preview-item d-flex align-items-center" href="!#" onClick={evt =>evt.preventDefault()}>
                    <div className="d-flex">
                      <div className="py-3 px-4 d-flex align-items-center justify-content-center">
                        <i className="mdi mdi-bookmark-plus-outline mr-0"></i>
                      </div>
                      <div className="py-3 px-4 d-flex align-items-center justify-content-center border-left border-right">
                        <i className="mdi mdi-account-outline mr-0"></i>
                      </div>
                      <div className="py-3 px-4 d-flex align-items-center justify-content-center">
                        <i className="mdi mdi-alarm-check mr-0"></i>
                      </div>
                    </div>
                  </Dropdown.Item>
                  <Dropdown.Item className="dropdown-item preview-item d-flex align-items-center text-small" onClick={evt =>evt.preventDefault()}>
                    Manage Accounts
                  </Dropdown.Item>
                  <Dropdown.Item className="dropdown-item preview-item d-flex align-items-center text-small" onClick={evt =>evt.preventDefault()}>
                  Change Password 
                  </Dropdown.Item>
                  <Dropdown.Item className="dropdown-item preview-item d-flex align-items-center text-small" onClick={evt =>evt.preventDefault()}>
                    Check Inbox
                  </Dropdown.Item>
                  <Dropdown.Item className="dropdown-item preview-item d-flex align-items-center text-small" onClick={evt =>evt.preventDefault()}>
                    Sign Out
                  </Dropdown.Item>
                </Dropdown.Menu> */}
                </Dropdown>
                {/* <button className="btn btn-success btn-block">New Project <i className="mdi mdi-plus"></i></button> */}
              </div>
            </li>
            <li className={this.isPathActive('/dashboards') ? 'nav-item active' : 'nav-item'}>
              <Link className="nav-link" to="/dashboard">
                <i className="mdi mdi-monitor-dashboard menu-icon"></i>
                <span className="menu-title">Dashboard</span>
              </Link>
            </li>
            <li className={this.isPathActive('/dashboard/cadastro') ? 'nav-item active' : 'nav-item'}>
              <div className={this.state.cadastroUiMenuOpen ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => this.toggleMenuState('cadastroUiMenuOpen')} data-toggle="collapse">
                <i className="mdi mdi-account-supervisor-outline menu-icon"></i>
                <span className="menu-title">Cadastro</span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.cadastroUiMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/cadastro/empresas') ? 'nav-link active' : 'nav-link'} to="/dashboard/cadastro/empresas"><i className="mdi mdi-home-city-outline menu-icon"></i>Empresas</Link></li>
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/cadastro/funcionarios') ? 'nav-link active' : 'nav-link'} to="/dashboard/cadastro/funcionarios"><i className="mdi mdi-human-greeting menu-icon"></i>Funcionários</Link></li>
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/cadastro/unidade') ? 'nav-link active' : 'nav-link'} to="/dashboard/cadastro/unidades"><i className="mdi mdi-window-restore menu-icon"></i>Unidades / Lotações</Link></li>
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/cadastro/setores') ? 'nav-link active' : 'nav-link'} to="/dashboard/cadastro/setores"><i className="mdi mdi-tooltip-text-outline menu-icon"></i>Setores</Link></li>
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/cadastro/cargos') ? 'nav-link active' : 'nav-link'} to="/dashboard/cadastro/cargos"><i className="mdi mdi-timeline-text-outline menu-icon"></i>Cargos</Link></li>
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/cadastro/sindicatos') ? 'nav-link active' : 'nav-link'} to="/dashboard/cadastro/sindicatos"><i className="mdi mdi-page-next-outline menu-icon"></i>Sindicatos</Link></li>
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/cadastro/layouts') ? 'nav-link active' : 'nav-link'} to="/dashboard/cadastro/layouts"><i className="mdi mdi-minus-box-multiple-outline menu-icon"></i>Layouts TXT</Link></li>
                  {/* <li className="nav-item"> <Link className={this.isPathActive('/dashboard/cadastro/tiposUsuarios') ? 'nav-link active' : 'nav-link'} to="/dashboard/cadastro/tiposUsuarios"><i className="mdi mdi-account-group menu-icon"></i>Tipos de Usuários</Link></li> */}
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/cadastro/usuarios') ? 'nav-link active' : 'nav-link'} to="/dashboard/cadastro/usuarios"><i className="mdi mdi-account-supervisor-outline menu-icon"></i>Usuários</Link></li>
                </ul>
              </Collapse>
            </li>
            <li className={this.isPathActive('/dashboard/escala') ? 'nav-item active' : 'nav-item'}>
              <div className={this.state.escalaUiMenuOpen ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => this.toggleMenuState('escalaUiMenuOpen')} data-toggle="collapse">
                <i className="mdi mdi-file-table-box-multiple-outline menu-icon"></i>
                <span className="menu-title">Escalas</span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.escalaUiMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/escala/horarios') ? 'nav-link active' : 'nav-link'} to="/dashboard/escala/horarios"><i className="mdi mdi-account-clock menu-icon"></i>Horários</Link></li>
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/escala/semanal') ? 'nav-link active' : 'nav-link'} to="/dashboard/escala/semanal"><i className="mdi mdi-chart-scatter-plot menu-icon"></i>Semanal</Link></li>
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/escala/especial') ? 'nav-link active' : 'nav-link'} to="/dashboard/escala/especial"><i className="mdi mdi-chart-timeline menu-icon"></i>Especial</Link></li>
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/escala/funcionarioXescala') ? 'nav-link active' : 'nav-link'} to="/dashboard/escala/funcionarioXescala"><i className="mdi mdi-grid-off menu-icon"></i>Funcionário X Escala</Link></li>
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/escala/ocorrencias') ? 'nav-link active' : 'nav-link'} to="/dashboard/escala/tipoOcorrencia"><i className="mdi mdi-tooltip-plus menu-icon"></i>Tipo de Ocorrências</Link></li>
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/escala/feriados') ? 'nav-link active' : 'nav-link'} to="/dashboard/escala/feriados"><i className="mdi mdi-book menu-icon"></i>Feriados</Link></li>
                </ul>
              </Collapse>
            </li>
            <li className={this.isPathActive('/dashboard/movimentac') ? 'nav-item active' : 'nav-item'}>
              <div className={this.state.movimentacaoUiMenuOpen ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => this.toggleMenuState('movimentacaoUiMenuOpen')} data-toggle="collapse">
                <i className="mdi mdi-clipboard-text-play-outline menu-icon"></i>
                <span className="menu-title">Movimentações</span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.movimentacaoUiMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/movimentacoes/importAFD') ? 'nav-link active' : 'nav-link'} to="/dashboard/movimentacoes/importAFD"><i className="mdi mdi-file-export-outline menu-icon"></i>Importar arquivo AFD</Link></li>

                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/movimentacoes/lancarOcorrencias') ? 'nav-link active' : 'nav-link'} to="/dashboard/movimentacoes/lancarOcorrencias"><i className="mdi mdi-book-open-page-variant menu-icon"></i>Lançar Ocorrências</Link></li>
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/movimentacoes/processarPonto') ? 'nav-link active' : 'nav-link'} to="/dashboard/movimentacoes/processarPonto"><i className="mdi mdi-calendar-multiple-check menu-icon"></i>Processar Ponto</Link></li>
                  
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/movimentacoes/arquivos_AFDT') ? 'nav-link active' : 'nav-link'} to="/dashboard/movimentacoes/arquivos_AFDT"><i className="mdi mdi-file-image-outline menu-icon"></i>Arquivos AFDT</Link></li>
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/movimentacoes/arquivos_ACJEF') ? 'nav-link active' : 'nav-link'} to="/dashboard/movimentacoes/arquivos_ACJEF"><i className="mdi mdi-file-image menu-icon"></i>Arquivos ACJEF</Link></li>
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/movimentacoes/folhaDePagamento') ? 'nav-link active' : 'nav-link'} to="/dashboard/movimentacoes/folhaDePagamento"><i className="mdi mdi-file-document-edit-outline menu-icon"></i>Folha de Pagamento</Link></li>
                  
                  
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/movimentacoes/limparBH') ? 'nav-link active' : 'nav-link'} to="/dashboard/movimentacoes/limparBH"><i className="mdi mdi-file-excel menu-icon"></i>Limpar Banco de Horas</Link></li>
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/movimentacoes/saldoExcedenteBH') ? 'nav-link active' : 'nav-link'} to="/dashboard/movimentacoes/saldoExcedenteBH"><i className="mdi mdi-file-document-box-check-outline menu-icon"></i>Saldo Excedente BH</Link></li>
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/movimentacoes/visualizarMarcacoes') ? 'nav-link active' : 'nav-link'} to="/dashboard/movimentacoes/visualizarMarcacoes"><i className="mdi mdi-file-find menu-icon"></i>Visualizar Marcações</Link></li>
                </ul>
              </Collapse>
            </li>
            <li className={this.isPathActive('/dashboard/ferramenta') ? 'nav-item active' : 'nav-item'}>
              <div className={this.state.ferramentaUiMenuOpen ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => this.toggleMenuState('ferramentaUiMenuOpen')} data-toggle="collapse">
                <i className="mdi mdi-message-settings-variant-outline menu-icon"></i>
                <span className="menu-title">Ferramentas</span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.ferramentaUiMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/ferramentas/notificacao-push') ? 'nav-link active' : 'nav-link'} to="/dashboard/ferramentas/notificacao-push"><i className="mdi mdi-file-move-outline menu-icon"></i>Notificação Push</Link></li>
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/ferramentas/auditoria') ? 'nav-link active' : 'nav-link'} to="/dashboard/ferramentas/auditoria"><i className="mdi mdi-chart-line menu-icon"></i>Auditoria</Link></li>
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/ferramentas/ifvArquivoTexto') ? 'nav-link active' : 'nav-link'} to="/dashboard/ferramentas/ifvArquivoTexto"><i className="mdi mdi-note-plus menu-icon"></i>Importar Funcionários Via<br /> Arquivo Texto</Link></li>
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/ferramentas/gaFiscais') ? 'nav-link active' : 'nav-link'} to="/dashboard/ferramentas/gaFiscais"><i className="mdi mdi-content-save-all-outline menu-icon"></i>Gerar Arquivos Fiscais</Link></li>
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/ferramentas/ceFolhaPagamento') ? 'nav-link active' : 'nav-link'} to="/dashboard/ferramentas/ceFolhaPagamento"><i className="mdi mdi-file-code-outline menu-icon"></i>Códigos de Exportação para<br /> Folha de Pagamento</Link></li>
                </ul>
              </Collapse>
            </li>
            <li className={this.isPathActive('/dashboard/relatorio') ? 'nav-item active' : 'nav-item'}>
              <div className={this.state.relatorioUiMenuOpen ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => this.toggleMenuState('relatorioUiMenuOpen')} data-toggle="collapse">
                <i className="mdi mdi-file-replace-outline menu-icon"></i>
                <span className="menu-title">Relatórios</span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.relatorioUiMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/relatorios/bancoHoras') ? 'nav-link active' : 'nav-link'} to="/dashboard/relatorios/bancoHoras"><i className="mdi mdi-chart-bar menu-icon"></i>Banco de Horas</Link></li>
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/relatorios/marcacoesOriginais') ? 'nav-link active' : 'nav-link'} to="/dashboard/relatorios/marcacoesOriginais"><i className="mdi mdi-checkbox-multiple-marked menu-icon"></i>Marcações Originais</Link></li>
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/relatorios/valesTransportes') ? 'nav-link active' : 'nav-link'} to="/dashboard/relatorios/valesTransportes"><i className="mdi mdi-folder-account menu-icon"></i>Vales Transportes</Link></li>
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/relatorios/adicionalNoturno') ? 'nav-link active' : 'nav-link'} to="/dashboard/relatorios/adicionalNoturno"><i className="mdi mdi-clock-check-outline menu-icon"></i>Adicional Noturno</Link></li>
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/relatorios/escalaSemanaXHorarios') ? 'nav-link active' : 'nav-link'} to="/dashboard/relatorios/escalaSemanaXHorarios"><i className="mdi mdi-chart-histogram menu-icon"></i>Escala Semana X Horarios</Link></li>
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/relatorios/funcionariosAIA') ? 'nav-link active' : 'nav-link'} to="/dashboard/relatorios/funcionariosAIA"><i className="mdi mdi-account-group menu-icon"></i>Funcionários (Ativos, <br />Inativos, Aniversariantes)</Link></li>
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/relatorios/absenteismo') ? 'nav-link active' : 'nav-link'} to="/dashboard/relatorios/absenteismo"><i className="mdi mdi-account-details menu-icon"></i>Absenteísmo</Link></li>
                </ul>
              </Collapse>
            </li>
            <li className={this.isPathActive('/dashboard/configuracao') ? 'nav-item active' : 'nav-item'}>
              <div className={this.state.configuracaoUiMenuOpen ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => this.toggleMenuState('configuracaoUiMenuOpen')} data-toggle="collapse">
                <i className="mdi mdi-settings-outline menu-icon"></i>
                <span className="menu-title">Configurações</span>
                <i className="menu-arrow"></i>

              </div>
              <Collapse in={this.state.configuracaoUiMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/configuracoes/configuracoes_info') ? 'nav-link active' : 'nav-link'} to="/dashboard/configuracoes/configuracoes_info"><i className="mdi mdi-progress-wrench menu-icon"></i>Configurações</Link></li>
                  <li className="nav-item"> <a className="nav-link" href="https://f4cil.com.br/" target="_blank"><i className="mdi mdi-cellphone-link menu-icon"></i>Sobre o PHPONTO</a></li>
                  <li className="nav-item"> <Link className={this.isPathActive('/dashboard/configuracoes/alterarSenha') ? 'nav-link active' : 'nav-link'} to="/dashboard/configuracoes/alterarSenha"><i className="mdi mdi-account-star menu-icon"></i>Alterar Senha</Link></li>
                </ul>
              </Collapse>
            </li>
            {/* <li className={ this.isPathActive('/basic-ui') ? 'nav-item active' : 'nav-item' }>
            <div className={ this.state.basicUiMenuOpen ? 'nav-link menu-expanded' : 'nav-link' } onClick={ () => this.toggleMenuState('basicUiMenuOpen') } data-toggle="collapse">
              <i className="mdi mdi-crosshairs-gps menu-icon"></i>
              <span className="menu-title">Basic UI Elements</span>
              <i className="menu-arrow"></i>
            </div>
            <Collapse in={ this.state.basicUiMenuOpen }>
              <ul className="nav flex-column sub-menu">
                <li className="nav-item"> <Link className={ this.isPathActive('/basic-ui/buttons') ? 'nav-link active' : 'nav-link' } to="/basic-ui/buttons">Buttons</Link></li>
                <li className="nav-item"> <Link className={ this.isPathActive('/basic-ui/dropdowns') ? 'nav-link active' : 'nav-link' } to="/basic-ui/dropdowns">Dropdowns</Link></li>
                <li className="nav-item"> <Link className={ this.isPathActive('/basic-ui/typography') ? 'nav-link active' : 'nav-link' } to="/basic-ui/typography">Typography</Link></li>
              </ul>
            </Collapse>
          </li>
          <li className={ this.isPathActive('/form-elements') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/form-elements/basic-elements">
              <i className="mdi mdi-format-list-bulleted menu-icon"></i>
              <span className="menu-title">Form Elements</span>
            </Link>
          </li>
          <li className={ this.isPathActive('/tables') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/tables/basic-table">
              <i className="mdi mdi-table-large menu-icon"></i>
              <span className="menu-title">Tables</span>
            </Link>
          </li>
          <li className={ this.isPathActive('/icons') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/icons/font-awesome">
              <i className="mdi mdi-account-box-outline menu-icon"></i>
              <span className="menu-title">Icons</span>
            </Link>
          </li>
          <li className={ this.isPathActive('/charts') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/charts/chart-js">
              <i className="mdi mdi-chart-line menu-icon"></i>
              <span className="menu-title">Charts</span>
            </Link>
          </li>
          <li className={ this.isPathActive('/user-pages') ? 'nav-item active' : 'nav-item' }>
            <div className={ this.state.userPagesMenuOpen ? 'nav-link menu-expanded' : 'nav-link' } onClick={ () => this.toggleMenuState('userPagesMenuOpen') } data-toggle="collapse">
              <i className="mdi mdi-lock-outline menu-icon"></i>
              <span className="menu-title">User Pages</span>
              <i className="menu-arrow"></i>
            </div>
            <Collapse in={ this.state.userPagesMenuOpen }>
              <ul className="nav flex-column sub-menu">
                <li className="nav-item"> <Link className={ this.isPathActive('/user-pages/blank-page') ? 'nav-link active' : 'nav-link' } to="/user-pages/blank-page">Blank Page</Link></li>
                <li className="nav-item"> <Link className={ this.isPathActive('/user-pages/login-1') ? 'nav-link active' : 'nav-link' } to="/user-pages/login-1">Login</Link></li>
                <li className="nav-item"> <Link className={ this.isPathActive('/user-pages/register-1') ? 'nav-link active' : 'nav-link' } to="/user-pages/register-1">Register</Link></li>
                <li className="nav-item"> <Link className={ this.isPathActive('/user-pages/error-404') ? 'nav-link active' : 'nav-link' } to="/user-pages/error-404">404</Link></li>
                <li className="nav-item"> <Link className={ this.isPathActive('/user-pages/error-500') ? 'nav-link active' : 'nav-link' } to="/user-pages/error-500">500</Link></li>
              </ul>
            </Collapse>
          </li> */}
            {/* <li className={ this.isPathActive('/cliente') ? 'nav-item active' : 'nav-item' }>
            <div className={ this.state.cadastroUiMenuOpen ? 'nav-link menu-expanded' : 'nav-link' } onClick={ () => this.toggleMenuState('cadastroUiMenuOpen') } data-toggle="collapse">
              <i className="mdi mdi-storefront menu-icon"></i>
              <span className="menu-title">Clientes</span>
              <i className="menu-arrow"></i>
            </div>
            <Collapse in={ this.state.cadastroUiMenuOpen }>
              <ul className="nav flex-column sub-menu">
                <li className="nav-item"> <Link className={ this.isPathActive('/cliente/todas') ? 'nav-link active' : 'nav-link' } to="/cliente/todas"><i className="mdi mdi-account-group menu-icon"></i>Todos</Link></li>
              </ul>
            </Collapse>
          </li> */}
          </ul>}
      </nav>
    );
  }

  isPathActive(path) {
    const hasActive = this.props.location.pathname.startsWith(path);
    return hasActive
  }

  componentDidMount() {
    this.onRouteChanged();
    // add className 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
    const body = document.querySelector('body');
    document.querySelectorAll('.sidebar .nav-item').forEach((el) => {

      el.addEventListener('mouseover', function () {
        if (body.classList.contains('sidebar-icon-only')) {
          el.classList.add('hover-open');
        }
      });
      el.addEventListener('mouseout', function () {
        if (body.classList.contains('sidebar-icon-only')) {
          el.classList.remove('hover-open');
        }
      });
    });
  }

}
const mapStateToProps = (state) => ({
  usuario: state.user.usuario,
  imagemUrl: state.user.imagemUrl,
  tipoUsuario: state.user.tipoUsuario,
  loading: state.user.loading
})
export default connect(mapStateToProps)(withRouter(Sidebar));